export default __webpack_public_path__ + "static/media/livvie.006dd3de.png";